function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as o } from "react/jsx-runtime";
import { useIsInverseVariant as s } from "../../theme-variant-context.js";
import { vars as c } from "../../skins/skin-contract.css-mistica.js";
const i = (_param)=>{
    var { color: a , size: r = 24  } = _param, t = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const h = s(), e = a !== null && a !== void 0 ? a : h ? c.colors.inverse : c.colors.neutralHigh;
    return /* @__PURE__ */ o("svg", _object_spread_props(_object_spread({
        width: r,
        height: r,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, t), {
        children: /* @__PURE__ */ o("path", {
            fill: e,
            d: "M21.837 5.935c0-.725-.563-1.316-1.254-1.316H3.406c-.692 0-1.255.59-1.255 1.316V18.07c0 .725.563 1.316 1.258 1.316h17.174c.692 0 1.255-.59 1.255-1.316V5.935zm-.82 0V18.07a.446.446 0 01-.434.453H3.406a.444.444 0 01-.434-.453V5.935a.442.442 0 01.434-.453h17.177c.246.005.44.21.434.453zm-10.025 7.46a.42.42 0 01.408.431.42.42 0 01-.408.431H4.328a.422.422 0 01-.412-.43.42.42 0 01.409-.432h6.667zm-7.073-3.017a.42.42 0 00.409.431h4.52a.42.42 0 00.41-.431.42.42 0 00-.41-.431h-4.52a.422.422 0 00-.41.43zm11.952-.995c.154-.156.434-.19.644-.19.21 0 .49.034.647.193.13.13.194.362.194.69 0 .327-.068.557-.194.686-.154.154-.436.187-.647.187-.21 0-.49-.033-.644-.187-.157-.16-.19-.463-.19-.687 0-.227.033-.529.19-.692zm-.571 1.995c.28.286.689.431 1.213.431.523 0 .932-.143 1.215-.431.297-.294.446-.734.446-1.305 0-.572-.152-1.014-.446-1.311-.283-.286-.692-.432-1.215-.432-.521 0-.933.146-1.213.432-.294.297-.443.74-.443 1.31 0 .572.149 1.012.443 1.306zm3.336 3.042h-4.241c.011-.219.067-.49.244-.684.224-.246.594-.3.862-.3h2.023c.269 0 .636.051.865.3.182.196.236.465.247.684zm.344-1.283c-.339-.37-.843-.566-1.456-.566h-2.02c-.613 0-1.117.193-1.456.566-.311.342-.477.812-.477 1.367v.577a.194.194 0 00.188.199h5.513a.194.194 0 00.187-.199v-.577c0-.555-.165-1.025-.479-1.367z"
        })
    }));
}, d = i;
export { d as default };
